import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { api, getListItems } from '../../services/api';
import { getImageUrl } from '../../utils/imageUrl';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';

const DEFAULT_BG = '/assets/img/bg/team_bg_2.jpg';
const FALLBACK_THUMB = '/assets/img/team/team_1_1.jpg';
const FALLBACK_BANNER = '/assets/img/team/team_img_1.jpg';

function guidePhoto(url, fallback) {
  const src = getImageUrl(url, 'team');
  if (!src || /placeholder|placehold|280\s*[x×]\s*280/i.test(src)) {
    return fallback;
  }
  return src;
}

function TourGuideTwo() {
  const [guides, setGuides] = useState([]);
  const { content } = useSiteContent('about');

  const subtitle = sectionField(content, 'guides', 'subtitle', 'Meet with Guide');
  const title = sectionField(content, 'guides', 'title', 'Meet with Tour Guide');
  const bgImage = sectionField(content, 'guides', 'bg_image', DEFAULT_BG);
  const defaultRole = sectionField(content, 'guides', 'role_label', 'Tourist Guide');

  useEffect(() => {
    let cancelled = false;
    api.getGuides()
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res).map((g) => ({
          id: g.id,
          name: g.name || g.title || 'Guide',
          role: g.designation || defaultRole,
          thumb: guidePhoto(g.thumb || g.image, FALLBACK_THUMB),
          banner: guidePhoto(g.image || g.thumb, FALLBACK_BANNER),
        }));
        setGuides(items);
      })
      .catch(() => setGuides([]));
    return () => { cancelled = true; };
  }, [defaultRole]);

  if (!guides.length) {
    return null;
  }

  return (
    <section
      className="team-area3 position-relative bg-top-center space"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        zIndex: '1',
        paddingBottom: '0',
      }}
    >
      <div className="container z-index-common">
        <div className="title-area text-center">
          <span className="sub-title">{subtitle}</span>
          <h2 className="sec-title">{title}</h2>
        </div>
        <div className="slider-area">
          <Swiper
            slidesPerView={3}
            spaceBetween={24}
            loop={guides.length > 3}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
            navigation={{
              prevEl: '.teamSlider3-prev',
              nextEl: '.teamSlider3-next',
            }}
            pagination={{ clickable: true }}
            modules={[Navigation, Pagination]}
            className="th-slider teamSlider3 has-shadow"
          >
            {guides.map((guide) => (
              <SwiperSlide key={guide.id}>
                <div className="th-team team-grid">
                  <div className="team-img">
                    <img
                      src={guide.banner}
                      alt={guide.name}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = FALLBACK_BANNER;
                      }}
                    />
                  </div>
                  <div className="team-img2">
                    <img
                      src={guide.thumb}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = FALLBACK_THUMB;
                      }}
                    />
                  </div>
                  <div className="team-content">
                    <div className="media-body">
                      <h3 className="box-title">
                        <Link to={`/tour-guide/${guide.id}`}>{guide.name}</Link>
                      </h3>
                      <span className="team-desig">{guide.role}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button type="button" className="slider-arrow slider-prev teamSlider3-prev" aria-label="Previous">
            <img src="/assets/img/icon/right-arrow2.svg" alt="" />
          </button>
          <button type="button" className="slider-arrow slider-next teamSlider3-next" aria-label="Next">
            <img src="/assets/img/icon/left-arrow2.svg" alt="" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default TourGuideTwo;
